/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CarCreatePayload } from '../models/CarCreatePayload';
import type { CarResource } from '../models/CarResource';
import type { CarUpdatePayload } from '../models/CarUpdatePayload';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CarsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any Cars list
     * @throws ApiError
     */
    public carControllerGetCars({
        contractId,
        limit,
        offset,
    }: {
        contractId?: number,
        limit?: number,
        offset?: number,
    }): CancelablePromise<{
        items: Array<CarResource>;
        total: number;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/cars',
            query: {
                'contract_id': contractId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid payload`,
                401: `Unauthorized`,
                403: `Contract not accessible`,
                404: `Not found`,
                409: `Duplicate car number`,
            },
        });
    }
    /**
     * @returns CarResource Car created
     * @throws ApiError
     */
    public carControllerPostCar({
        requestBody,
    }: {
        requestBody: CarCreatePayload,
    }): CancelablePromise<CarResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/cars',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid payload`,
                401: `Unauthorized`,
                403: `Contract not accessible`,
                404: `Not found`,
                409: `Duplicate car number`,
            },
        });
    }
    /**
     * @returns CarResource Car
     * @throws ApiError
     */
    public carControllerGetCar({
        id,
    }: {
        id: number,
    }): CancelablePromise<CarResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/cars/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid payload`,
                401: `Unauthorized`,
                403: `Contract not accessible`,
                404: `Not found`,
                409: `Duplicate car number`,
            },
        });
    }
    /**
     * @returns CarResource Car
     * @throws ApiError
     */
    public carControllerPutCar({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: CarUpdatePayload,
    }): CancelablePromise<CarResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/cars/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid payload`,
                401: `Unauthorized`,
                403: `Contract not accessible`,
                404: `Not found`,
                409: `Duplicate car number`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public carControllerDeleteCar({
        id,
    }: {
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/cars/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid payload`,
                401: `Unauthorized`,
                403: `Contract not accessible`,
                404: `Not found`,
                409: `Duplicate car number`,
            },
        });
    }
}
